export default __webpack_public_path__ + "static/media/10.e1e156c8.png";